var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.isShow
        ? _vm.isShowHead
          ? [_vm.$style.box, _vm.$style.container]
          : [_vm.$style.boxb, _vm.$style.container]
        : _vm.$style.container},[(_vm.isShowHead)?_c('Header',{class:_vm.$style.header,attrs:{"headerIndex":_vm.headerIndex}}):_vm._e(),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keep)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('Footor',{class:_vm.$style.footer,attrs:{"index":_vm.index}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d34fba04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Okv4
// module chunks = 86